import React, { useEffect, useState } from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    TextField,
} from "@mui/material";
import * as APIModels from "../../../../models";
import { SubmissionService } from "../../../../services/SubmissionService";
import {
    ClientService,
    PortalConfigurationService,
} from "../../../../services/ClientService";
import PortalSelector from "../../../../components/shared/PortalSelector";
import { DataService } from "../../../../services/DataService";

export interface AttorneyAuthorizationParams {
    attorneyId: string;
    attorneyName: string;
    portalId: string;
    isOpen: boolean;
    handleClose: () => void;
}

export default function AttorneyAuthorizationModal(
    params: AttorneyAuthorizationParams
) {
    const { attorneyName, attorneyId, portalId, isOpen, handleClose } = params;
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [portalConfiguration, setPortalConfiguration] = useState<
        APIModels.PortalConfiguration | undefined
    >(undefined);
    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const setCredentials = (data: APIModels.PortalCredentials) => {
        if (data.username) {
            setUsername(data.username);
        }
        if (data.password) {
            setPassword(data.password);
        }
    };
    const getPortalConfigurationByState = async (): Promise<
        APIModels.PortalConfiguration | undefined
    > => {
        const resp = await PortalConfigurationService.getList({
            attorneyId: attorneyId ?? "",
        });

        if (resp.successful && resp.data) {
            return resp.data.find((p) => p.portalIdentifier === portalId);
        }

        return undefined;
    };

    useEffect(() => {
        PortalConfigurationService.getCredentials({
            portalConfigId: portalConfiguration?.id ?? "",
        }).then(
            (resp) => {
                if (resp.successful === true) {
                    setCredentials(resp.data as APIModels.PortalCredentials);
                } else {
                    console.log("Error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [portalConfiguration]);

    useEffect(() => {
        if (isOpen) {
            getPortalConfigurationByState().then((data) => {
                setPortalConfiguration(data);
            });
        }
    }, [isOpen]);

    const calculate = async (data: APIModels.PortalConfiguration) => {
        let portal = "";
        const _ = (await DataService.getStates()).find((s) => {
            if (s.abbreviation === data.state) {
                portal = s.portal ?? "";
                portal = data.state === "GA" ? portal.split(",")[0] : portal;
            } else if (data.state === "GO") {
                // odessy
                portal = s.portal ?? "";
                portal.split(",")[1];
            }
            console.log(portal);
            return s.abbreviation === data.state;
        });
        return portal;
    };

    return (
        <Dialog open={isOpen} onClose={handleClose} hideBackdrop maxWidth="lg">
            <DialogTitle>
                Get Attorney Credentials and Open Filing Portal
            </DialogTitle>
            <DialogContent>
                <Stack direction="column" spacing={2}>
                    <DialogContentText> {attorneyName} </DialogContentText>
                    <Stack direction="row" spacing={4}>
                        <TextField
                            required
                            id="outlined-required"
                            label="Username"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                            }}
                        />
                        <TextField
                            required
                            id="outlined-required"
                            label="Password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" spacing={2}>
                    {error && <span style={{ color: "red" }}>{error}</span>}
                    <Button
                        onClick={async () => {
                            const portal = await calculate(
                                portalConfiguration as APIModels.PortalConfiguration
                            );
                            // open in a new tab
                            window.open(
                                portal,
                                "_blank",
                                "noopener,noreferrer"
                            );
                        }}
                    >
                        Open {portalId}'s Filing Portal
                    </Button>
                    <Button onClick={handleClose}>Close</Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
}
